import { formatApiDateTimeInZone } from '~/utils/formatApiDateTimeInZone'
import type { ClosureCode } from '~/services/api/generated'
import type { TranslateFn } from './TranslateFn'
import { resolveCode } from './resolveCode'
import { closureResolverMap } from './closureResolverMap'

export function resolveClosureMessage(
  closureCode: {
    code: ClosureCode
    params: { closed_until: string; operator_note?: string | null }
  },
  zone: string,
  t: TranslateFn
): string {
  if (closureCode.params.operator_note != null && closureCode.params.operator_note !== '') {
    return closureCode.params.operator_note
  }

  return resolveCode(
    {
      code: closureCode.code,
      params: { closed_until: formatApiDateTimeInZone(closureCode.params.closed_until, zone) }
    },
    closureResolverMap,
    t
  )
}
